<template>
    <div class="as-checkbox-group">
        <el-checkbox-group v-model="selectValue" class="custom-column__checkboxs">
            <el-checkbox v-for="(column, index) in options" :label="column.key" :key="index">{{column.title}}</el-checkbox>
        </el-checkbox-group>
    </div>
</template>

<script>
export default {
    name: 'asCheckboxGroup',
    props: {
        options: Array,
        value: Array,
    },
    data() {
        return {
            selectValue: [],
        }
    },
    watch: {
        options() {
            console.log('options', this.options);
        },
        value(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.selectValue = newValue;
            }
        },
        selectValue() {
            this.$emit('input', this.selectValue);
        },
    },
    mounted() {
        this.selectValue = this.value;
    }
}
</script>